import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=44bcaa95&scoped=true&"
import script from "./UserMain.vue?vue&type=script&setup=true&lang=ts&"
export * from "./UserMain.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./UserMain.vue?vue&type=style&index=0&id=44bcaa95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcaa95",
  null
  
)

export default component.exports